import styled from 'styled-components';
import {
  lighten,
} from 'polished';

import {
  Flex,
} from 'web-styled';

export const CalendarContainer = styled(Flex).attrs({
  fillSpace: true,
  align: 'center',
  justify: 'center',
})`
  height: 650px;

  .rbc-overlay {
    width: 259px;
  }
  .rbc-today {
    background-color: ${props => lighten(0.3, props.theme.colors.primary)};
  }
  .rbc-event {
    background-color: ${props => props.theme.colors.rbcEvent};
  }
`;

export const Event = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  border-top: 2px solid ${props => props.theme.colors.eventBorderColor || props.color};
`;
